import { dataOnAuthStateChanged } from "../../main/data/data";
export function isAuth(authIn, authOut) {
    dataOnAuthStateChanged((user) => {
        // authIn(user);
        if (user) {
            if (typeof authIn === "function") {
                authIn(user);
            }
        }
        else {
            if (typeof authOut === "function") {
                authOut(user);
            }
        }
    });
}
